"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var Text_1 = __importDefault(require("../../Text"));
var style = react_1.css({
    padding: '0 6px',
    background: style_1.DesignSystemThemeColor.Gray.LIGHT_4,
    color: style_1.DesignSystemThemeColor.Gray.DARK_4,
    borderRadius: 3,
    ':last-child': {
        marginRight: -6,
    },
});
var ChipBadge = function (_a) {
    var children = _a.children;
    return (react_1.jsx(Text_1.default.Body, { weight: "semibold", css: style }, children));
};
exports.default = ChipBadge;
